// Sector category definitions for the Advanced Filter Modal
// Maps high-level sector categories to display labels

export interface SectorCategory {
  value: string;
  label: string;
  description: string;
}

export const SECTOR_CATEGORIES: SectorCategory[] = [
  { value: 'technology', label: 'Technology', description: 'Software, Hardware, Semiconductors' },
  { value: 'healthcare', label: 'Healthcare', description: 'Pharma, Biotech, Medical Devices' },
  { value: 'financial', label: 'Financial Services', description: 'Banks, Insurance, Investment' },
  { value: 'consumer_discretionary', label: 'Consumer Discretionary', description: 'Retail, Automotive, Leisure' },
  { value: 'consumer_staples', label: 'Consumer Staples', description: 'Food, Beverage, Household' },
  { value: 'industrials', label: 'Industrials', description: 'Aerospace, Defense, Transportation' },
  { value: 'energy', label: 'Energy', description: 'Oil, Gas, Petroleum' },
  { value: 'utilities', label: 'Utilities', description: 'Electric, Water, Gas Distribution' },
  { value: 'materials', label: 'Materials', description: 'Chemicals, Mining, Metals' },
  { value: 'real_estate', label: 'Real Estate', description: 'REITs, Property Management' },
  { value: 'communication', label: 'Communication Services', description: 'Media, Telecom, Broadcasting' },
  { value: 'services', label: 'Business Services', description: 'Professional & Business Services' },
  { value: 'unknown', label: 'Unknown', description: 'No sector data available' },
  { value: 'other', label: 'Other', description: 'Unclassified sectors' },
];

export const MARKET_CAP_CATEGORIES = [
  { value: 'mega', label: 'Mega Cap', description: '>$200B' },
  { value: 'large', label: 'Large Cap', description: '$10B-$200B' },
  { value: 'mid', label: 'Mid Cap', description: '$2B-$10B' },
  { value: 'small', label: 'Small Cap', description: '$300M-$2B' },
  { value: 'micro', label: 'Micro Cap', description: '<$300M' },
];

export const SPREAD_BUCKETS = [
  { value: 'excellent', label: 'Excellent', description: '<1%', maxSpread: 1 },
  { value: 'very_good', label: 'Very Good', description: '1-2%', minSpread: 1, maxSpread: 2 },
  { value: 'good', label: 'Good', description: '2-3%', minSpread: 2, maxSpread: 3 },
  { value: 'acceptable', label: 'Acceptable', description: '3-5%', minSpread: 3, maxSpread: 5 },
  { value: 'poor', label: 'Poor', description: '5-10%', minSpread: 5, maxSpread: 10 },
  { value: 'very_poor', label: 'Very Poor', description: '10-20%', minSpread: 10, maxSpread: 20 },
  { value: 'untradeable', label: 'Untradeable', description: '>20%', minSpread: 20 },
];

export const TREND_SIGNALS = [
  { value: 'Golden Cross', label: 'Golden Cross', description: 'Price > SMA200 & SMA50 > SMA200' },
  { value: 'Bullish', label: 'Bullish', description: 'Price > SMA200' },
  { value: 'Value Dip', label: 'Value Dip', description: 'SMA50 > SMA200, price below' },
  { value: 'Bearish', label: 'Bearish', description: 'Price & SMA50 below SMA200' },
  { value: 'No Data', label: 'No Data', description: 'Missing SMA data' },
];

// Get sector label by value
export const getSectorLabel = (value: string): string => {
  const sector = SECTOR_CATEGORIES.find(s => s.value === value);
  return sector?.label || value;
};

// Get market cap label by value
export const getMarketCapLabel = (value: string): string => {
  const cap = MARKET_CAP_CATEGORIES.find(c => c.value === value);
  return cap?.label || value;
};
